import { CancelCircleFilledIcon, InfoIcon, WarningIcon, TickCircleFilledIcon } from '@deliveryhero/armor-icons';
import { messageLevels } from '../constants';
export var useIconComponent = function useIconComponent(_ref) {
  var level = _ref.level,
      warning = _ref.warning,
      success = _ref.success,
      error = _ref.error;

  if (warning || level === messageLevels.warning) {
    return WarningIcon;
  }

  if (error || level === messageLevels.error) {
    return CancelCircleFilledIcon;
  }

  if (success || level === messageLevels.success) {
    return TickCircleFilledIcon;
  }

  return InfoIcon;
};